import React from 'react';
import ReactDOM from 'react-dom';

const Portal = ({ parent, children }) => (
  ReactDOM.createPortal((
    <>
      {children}
    </>
  ), parent)
);

export default Portal;
